<script lang="ts" setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M19 14.25C19 14.8099 18.7776 15.3469 18.3817 15.7428C17.9858 16.1387 17.4488 16.3611 16.8889 16.3611H2.11111C1.55121 16.3611 1.01424 16.1387 0.61833 15.7428C0.22242 15.3469 0 14.8099 0 14.25V4.75003C0 4.19013 0.22242 3.65316 0.61833 3.25725C1.01424 2.86134 1.55121 2.63892 2.11111 2.63892H16.8889C17.4488 2.63892 17.9858 2.86134 18.3817 3.25725C18.7776 3.65316 19 4.19013 19 4.75003V14.25Z"
      fill="#C60A1D"
    />
    <path d="M0 6.33325H19V12.6666H0V6.33325Z" fill="#FFC400" />
    <path
      d="M4.75 8.97217V10.5555C4.75 10.9754 4.91681 11.3782 5.21375 11.6751C5.51068 11.972 5.91341 12.1388 6.33333 12.1388C6.75326 12.1388 7.15599 11.972 7.45292 11.6751C7.74985 11.3782 7.91667 10.9754 7.91667 10.5555V8.97217H4.75Z"
      fill="#EA596E"
    />
    <path d="M6.33301 8.44434H7.91634V10.0277H6.33301V8.44434Z" fill="#F4A2B2" />
    <path d="M4.75 8.44434H6.33333V10.0277H4.75V8.44434Z" fill="#DD2E44" />
    <path
      d="M6.33333 8.44442C7.20778 8.44442 7.91667 8.08998 7.91667 7.65275C7.91667 7.21553 7.20778 6.86108 6.33333 6.86108C5.45888 6.86108 4.75 7.21553 4.75 7.65275C4.75 8.08998 5.45888 8.44442 6.33333 8.44442Z"
      fill="#EA596E"
    />
    <path
      d="M6.33333 7.65275C7.20778 7.65275 7.91667 7.47553 7.91667 7.25692C7.91667 7.0383 7.20778 6.86108 6.33333 6.86108C5.45888 6.86108 4.75 7.0383 4.75 7.25692C4.75 7.47553 5.45888 7.65275 6.33333 7.65275Z"
      fill="#FFAC33"
    />
    <path
      d="M3.69434 8.44434H4.22211V12.1388H3.69434V8.44434ZM8.44434 8.44434H8.97211V12.1388H8.44434V8.44434Z"
      fill="#99AAB5"
    />
    <path
      d="M3.16699 11.6112H4.75033V12.139H3.16699V11.6112ZM7.91699 11.6112H9.50033V12.139H7.91699V11.6112ZM3.69477 7.91675H4.22255V8.44453H3.69477V7.91675ZM8.44477 7.91675H8.97255V8.44453H8.44477V7.91675Z"
      fill="#66757F"
    />
  </svg>
</template>
